import Vue from 'vue';

export default {
  state: {
    genders: [],
  },
  getters: {
    genders(state) {
      return state.genders;
    },
    // eslint-disable-next-line
    gender: state => (id) => {
      return state.genders.find(type => type.id === id) || {};
    },
  },
  mutations: {
    SET_GENDERS(state, payload) {
      state.genders = payload;
    },
  },
  actions: {
    GET_GENDERS(context) {
      return Vue.axios.get('filters/genders').then((response) => {
        context.commit('SET_GENDERS', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/genders.js